import React, { ReactNode, useState, useEffect } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

type TabsType = {
  defaultValue: any;
  children: ReactNode;
  activeTab?: any;
  setActiveTab?: any;
  className?: any;
  renderAllPanels?: boolean;
};

const Tabs = ({
  defaultValue,
  children,
  activeTab: controlledActiveTab,
  setActiveTab: setControlledActiveTab,
  className,
  renderAllPanels = false,
}: TabsType) => {
  const [activeTab, setActiveTab] = useState(defaultValue);

  useEffect(() => {
    if (defaultValue && !activeTab) {
      setActiveTab(defaultValue);
    }
  }, [defaultValue, activeTab]);

  return (
    <div className={className}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            activeTab: controlledActiveTab ?? activeTab,
            setActiveTab: setControlledActiveTab ?? setActiveTab,
            renderAllPanels,
          } as React.Attributes & { activeTab: string; setActiveTab: React.Dispatch<React.SetStateAction<string>>; renderAllPanels: boolean });
        }
        return child;
      })}
    </div>
  );
};

export default wrapperHOC(Tabs, {
  componentName: "Tabs-Global",
  showForChina: true,
});
